<template>
    <div style="padding: 50px 18px 18px;
   ">
        <div class="row mb-2">
            <div class="col-12">
                <a href="javascript:void(0)" @click="close" class="float-left">&lt;&lt; Back to messages</a>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12 text-left">{{messageHeader.subject}}</div>
        </div>
        <div class="row mb-2">
            <div class="col text-left">{{messageHeader.from}}</div>
            <div class="col text-right">
                <div class="btn-group" role="group" aria-label="Message actions">
                    <button v-if="replyButtonEnabled" type="button" class="btn btn-sm btn-secondary" @click="showReplyPanel(messageHeader)">Reply</button>
                    <button v-if="assignButtonEnabled" type="button" class="btn btn-sm btn-secondary" @click="showAssignPanel(messageHeader)">Assign</button>
                    <button v-if="tagButtonEnabled" type="button" class="btn btn-sm btn-secondary" @click="showTagPanel(messageHeader)">Tag</button>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col text-left">{{messageHeader.to}}</div>
            <div class="col text-right">{{messageHeader.documentDateCreatedDisplay}}</div>
        </div>
        <div class="row mb-2">
            <div v-for="(a, idx) in messageHeader.attachments" :key="'attachment_' + idx" class="card">
                <a class="attachmentLink" href="javascript:void(0);" @click="attachmentClick(a.id)">
                    <div class="card-body">
                        <i class="far fa-file-alt"></i> {{a.originalFilename}}
                    </div>
                </a>
            </div>
        </div>
        <div class="row mb-2">
            <div v-if="messageDocument.html" class="col-12 border text-left" v-html="cleanedMessageHtml"></div>
            <div v-else class="col-12 border text-left"><pre>{{messageDocument.text}}</pre></div>
        </div>
        <slideout-panel :key="'slideout-panel_assign_' + messageHeader.id"></slideout-panel>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import { DOWNLOAD_MESSAGE_ATTACHMENT } from '@/messageEvents.js';

    import { REPLY_MESSAGE, FORWARD_MESSAGE } from './composeActionTypes.js';

    export default {
        name: "message-viewer",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            messageHeader: {
                required: true
            },
            messageDocument: {
                required: true
            },
            buttonConfig: {
                type: Object,
                required: false,
                default: () => {
                    return {
                        reply: {
                            enabled: true
                        },
                        assign: {
                            enabled: true
                        },
                        tag: {
                            enabled: true
                        }
                    }
                }
            },
            availableTags: {
                type: Array,
                required: false,
                default: () => []
            },
            windowWidth: {
                required: true
            }
        },
        data: () => {
            return {};
        },
        computed: {
            cleanedMessageHtml() {
                return this.$sanitize(this.messageDocument.html);
            },
            replyButtonEnabled() {
                if (this.buttonConfig) {
                    if (this.buttonConfig.reply) {
                        return this.buttonConfig.reply.enabled
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            assignButtonEnabled() {
                if (this.buttonConfig) {
                    if (this.buttonConfig.assign) {
                        return this.buttonConfig.assign.enabled
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            tagButtonEnabled() {
                if (this.buttonConfig) {
                    if (this.buttonConfig.tag) {
                        return this.buttonConfig.tag.enabled
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        },
        methods: {
            showAssignPanel(message) {

                const panel1Handle = this.$showPanel({
                    component: "assign-to-claim",
                    openOn: "right",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        messageId: message.id
                    }
                });

                panel1Handle.promise.then(result => {
                    if (result && result.closeCaller == true) {
                        this.$emit('closePanel')
                    }
                });

            },
            showReplyPanel(message) {

                const panel1Handle = this.$showPanel({
                    component: "message-compose",
                    openOn: "right",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        message: { ...message, html: this.messageDocument.html.replace('\n', '') },
                        actionType: REPLY_MESSAGE
                    }
                });

                //panel1Handle.promise.then(result => {});

            },
            showTagPanel(message) {

                const panel1Handle = this.$showPanel({
                    component: "message-tag",
                    openOn: "right",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        messageId: message.id,
                        availableTags: this.availableTags,
                        //selectedTags: this.availableTags.filter( t => t.selected == true )
                    }
                });

                //panel1Handle.promise.then(result => {});

            },
            close() {
                this.$emit("closePanel");
            },
            attachmentClick(payload) {
                EventBus.$emit(DOWNLOAD_MESSAGE_ATTACHMENT + '_' + this.eventTarget, payload)
            }
        },
        mounted() {

        }
    };
</script>
<style scoped>
    .attachmentLink {
        text-decoration: none;
        color: inherit;
    }
</style>

